import React, { useState } from "react";
import "antd/dist/antd.css";
import { Button, Input, Form, Modal, Spin } from "antd";
import { withRouter, Link } from "react-router-dom";
import { createNewUser } from "../services/login";
import { regExp } from "../config";

const Index = props => {
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstnameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState({
    e: "",
    message: ""
  });

  const onSubmit = async () => {
    if (validation()) {
      setLoading(true);
      const userInfo = {
        firstName,
        lastName,
        emailId: email,
        password: password,
        mobileNo: mobile
      };
      try {
        await createNewUser(userInfo);
        setLoading(false);
        Modal.success({
          width: 520,
          title: "You have successfully created your account!",
          // "A verification link has been sent to your email account",
          // content: (
          //   <div>
          //     <p>
          //       Please click on the link that has just been sent to your email
          //       account to verify your email and countinue the registration
          //       process.
          //     </p>
          //   </div>
          // ),
          onOk() {
            props.history.push("/signin");
          }
        });
      } catch (error) {
        if (error.response.data.message === "Email is alrady exist") {
          setEmailError({ e: "error", message: "Email is already exist" });
        }
      }
    }
  };
  const validation = () => {
    setFirstnameError("");
    setLastNameError("");
    setEmailError("");
    setMobileError("");
    setPasswordError("");
    setConfirmPasswordError("");
    let formIsValid = true;
    if (!firstName) {
      formIsValid = false;
      setFirstnameError({ e: "error", message: "Enter First Name" });
    }
    if (!lastName) {
      formIsValid = false;
      setLastNameError({ e: "error", message: "Enter Last Name" });
    }
    if (!email) {
      formIsValid = false;
      setEmailError({ e: "error", message: "Enter Email" });
    } else {
      if (!regExp.email.test(email)) {
        formIsValid = false;
        setEmailError({ e: "error", message: "Enter a valid Email" });
      }
    }
    if (!mobile) {
      formIsValid = false;
      setMobileError({ e: "error", message: "Enter Mobile Number" });
    } else {
      if (!regExp.phone.test(mobile)) {
        formIsValid = false;
        setMobileError({ e: "error", message: "Enter a valid Moblie Number" });
      }
    }
    if (!password) {
      formIsValid = false;
      setPasswordError({ e: "error", message: "Enter a password" });
    } else {
      if (password.length < 6) {
        formIsValid = false;
        setPasswordError({
          e: "error",
          message: "Your password must be at least 6 characters"
        });
      }
      if (password.search(/[a-z]/i) < 0) {
        formIsValid = false;
        setPasswordError({
          e: "error",
          message: "Your password must contain at least one letter."
        });
      }
      if (password.search(/[0-9]/) < 0) {
        formIsValid = false;
        setPasswordError({
          e: "error",
          message: "Your password must contain at least one digit."
        });
      }
      if (password !== confirmPassword) {
        formIsValid = false;
        setConfirmPasswordError({
          e: "error",
          message: "Those passwords didn't match. Try again"
        });
        setConfirmPassword("");
      }
    }
    return formIsValid;
  };

  return (
    <div style={{ marginTop: 50 }}>
      <div className="card w-50" style={{ margin: "auto" }}>
        <div className="card-header">
          <h4>Create your Account</h4>
        </div>
        <div className="card-body">
          <Spin spinning={loading} size="large">
            <Form>
              <Form.Item
                //label="First Name"
                validateStatus={firstNameError.e}
                help={firstNameError.message}
              >
                <Input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  onChange={e => setFirstName(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                validateStatus={lastNameError.e}
                help={lastNameError.message}
              >
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  onChange={e => setLastName(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                validateStatus={mobileError.e}
                help={mobileError.message}
              >
                <Input
                  type="text"
                  name="mobileNumber"
                  placeholder="Mobile Number"
                  onChange={e => setMobile(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                validateStatus={emailError.e}
                help={emailError.message}
              >
                <Input
                  type="text"
                  name="email"
                  placeholder="Email"
                  onChange={e => setEmail(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                validateStatus={passwordError.e}
                help={passwordError.message}
              >
                <Input
                  type="password"
                  name="password"
                  placeholder="Password"
                  onChange={e => setPassword(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                validateStatus={confirmPasswordError.e}
                help={confirmPasswordError.message}
              >
                <Input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" onClick={onSubmit}>
                  Sign Up
                </Button>
              </Form.Item>
              Already have an account? <Link to="/signin">Sign in</Link>
            </Form>
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Index);
